import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { RgHttpService } from '../../http/rg-http.service'
import {
    ApiShortcutPreferences,
    KeyboardShortcutMe, KeyboardShortcutMeResponse,
    ResetKeyboardShortcutMe,
    SaveKeyboardShortcutMe
} from '../../contracts/shared/keyboard-shortcut.endpoints'

@Injectable({ providedIn: 'root' })
export class KeyboardShortcutApiService {
    constructor (private http: RgHttpService) { }

    get (userable: string): Observable<KeyboardShortcutMeResponse> {
        return this.http.call(KeyboardShortcutMe, { userable })
    }

    save (userable: string, prefs: ApiShortcutPreferences): Observable<KeyboardShortcutMeResponse> {
        return this.http.call(SaveKeyboardShortcutMe, { userable, ...prefs })
    }

    reset (userable: string): Observable<KeyboardShortcutMeResponse> {
        return this.http.call(ResetKeyboardShortcutMe, { userable })
    }
}
